import { format, startOfDay, subDays } from 'date-fns';

import type { EnvType, OrderFilterStatus, SourceType, TaskStatus, TemplatesProductCombinations } from 'api/types';
import { API_DATE_FORMAT } from 'shared/lib/datetime/formatDate';

import type { ExpiryBucket } from './expiryBuckets';
import { PeriodType } from './period';

export type Filters = {
  env: EnvType[];
  date_from: string;
  date_to: string;
  period?: string;
  orderStatuses?: OrderFilterStatus[];
  taskStatus?: TaskStatus;
  responseStatus?: string;
  product_type?: string;
  product_types?: string[];
  provider?: string;
  products?: TemplatesProductCombinations;
  source?: SourceType | '';
  expiry_bucket?: ExpiryBucket | '';
  logType?: 'webhook' | 'api';
  webhookConfigId?: string;
  eventType?: string;
  selectedLogId?: string;

  query?: string;

  page?: number;
  /** Position in a cursor-paginated list. Travels with `page`, which is only its label. */
  cursor?: string;
  page_size?: number;
  ordering?: string;
  link_exists?: boolean | null;
};

const DEFAULT_PERIOD_DAYS = 30;

export const DEFAULT_PERIOD_CODE = PeriodType.Last30Days;

export const DEFAULT_PAGE_SIZE = 20;

export const defaultFilters: Filters = {
  env: ['sandbox'],
  period: DEFAULT_PERIOD_CODE,
  date_from: format(subDays(startOfDay(new Date()), DEFAULT_PERIOD_DAYS), API_DATE_FORMAT),
  date_to: format(new Date(), API_DATE_FORMAT),
  page: 1,
  cursor: '',
  page_size: DEFAULT_PAGE_SIZE,
};
